import { LoadingButton } from "@mui/lab";
import { Alert, Button, Divider, Icon, Stack, Typography } from "@mui/material";
import { ChangeEvent, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SmsCampaignService } from "../../../api/psc";
import { CardInformation } from "../../../components/exports";
import { RootState } from "../../../slices/Store";
import { ValidateSmsCampaignExcelFile } from "../../../validations/SmsCampaignValidation";
import {
    setSmsCampaignExcelFile,
    smsCampaignNextStep,
    smsCampaignPrevStep,
} from "../smsCampaignSlice/SmsCampaignSlice";

// updated
export default function SmsCampaignExcelDestination() {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);

    const [error, setError] = useState<string | null>(null);

    const smsCampaign = useSelector((state: RootState) => state.smsCampaign);

    const [excelFileError, setExcelFileError] = useState<boolean>(false);
    const [excelFileUploading, setExcelFileUploading] =
        useState<boolean>(false);

    const handleFileChange = (ev: ChangeEvent<HTMLInputElement>) => {
        const file = ev.target.files[0];
        setExcelFileUploading(true);
        setExcelFileError(false);
        SmsCampaignService.storeExcelFile("1", {
            file: file,
        })
            .then((r) => {
                dispatch(
                    setSmsCampaignExcelFile({
                        fileId: r.id,
                        totalCount: r.contactCount,
                    })
                );
            })
            .catch((r) => {
                setExcelFileError(true);
            })
            .finally(() => {
                setExcelFileUploading(false);
            });
    };

    const handleOpenExcelFile = () => {
        fileInputRef.current.click();
    };

    const handleRemoveExcelFile = () => {
        dispatch(setSmsCampaignExcelFile(null));
    };

    const handlePrevious = () => {
        dispatch(smsCampaignPrevStep());
    };

    const handleNext = () => {
        const errorMessage = ValidateSmsCampaignExcelFile(smsCampaign);

        if (errorMessage) {
            setError(errorMessage);
            return;
        }

        dispatch(smsCampaignNextStep());
    };

    return (
        <Stack spacing={2}>
            <Alert severity="info">
                فایل اکسل مورد نظر را وارد کنید، توجه داشته باشید که ستون اول
                فایل اکسل میباستی شامل شماره موبایل ها با فرمت 09XXXXXXXXX یا
                فرمت 9XXXXXXXXX بوده و ستون دوم(که اختیاریست) میتواند شامل نام
                اشخاص باشد.
            </Alert>

            {!smsCampaign.excelFile && (
                <Stack direction="row" alignItems="center">
                    <Typography color="text.secondary" sx={{ flexGrow: 1 }}>
                        انتخاب فایل اکسل
                    </Typography>

                    <input
                        ref={fileInputRef}
                        type="file"
                        hidden
                        onChange={handleFileChange}
                    />

                    <LoadingButton
                        loading={excelFileUploading}
                        onClick={handleOpenExcelFile}
                        variant="outlined"
                        color="secondary"
                        startIcon={<Icon>attach_file</Icon>}
                    >
                        انتخاب فایل
                    </LoadingButton>
                </Stack>
            )}

            {smsCampaign.excelFile && (
                <>
                    <Alert
                        severity="success"
                        action={
                            <Button onClick={handleRemoveExcelFile}>
                                حذف فایل
                            </Button>
                        }
                    >
                        فایل اکسل آپلود شد
                    </Alert>

                    <CardInformation
                        title={"تعداد مخاطبین فایل"}
                        value={smsCampaign.excelFile.totalCount}
                    />
                </>
            )}

            {excelFileError && (
                <Alert severity="error">فایل اکسل وارد شده صحیح نیست</Alert>
            )}

            <Divider />

            {error && <Alert severity="error">{error}</Alert>}

            <Stack direction="row" justifyContent="space-between">
                <Button
                    onClick={handlePrevious}
                    variant="outlined"
                    startIcon={<Icon>navigate_next</Icon>}
                >
                    مرحله قبل
                </Button>

                <LoadingButton
                    onClick={handleNext}
                    variant="contained"
                    color="primary"
                    endIcon={<Icon>navigate_before</Icon>}
                >
                    مرحله بعد
                </LoadingButton>
            </Stack>
        </Stack>
    );
}
